"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeftPanel = void 0;
var _components = require("@ori-ui/components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../../../../contexts");
var _hooks = require("../../../../hooks");
var _models = require("../../../../models");
var _PickupPointCards = require("../PickupPointCards");
var _Search = require("../Search");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const LeftPanel = ({
  onPickupPointsListClick
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const {
    pickupPointsMapProps: {
      selectedMapPickupPoint,
      onPickupPointItemConfirmation
    }
  } = (0, _contexts.useMap)();
  const {
    selectedPickupPoint,
    loading
  } = (0, _contexts.usePickupPoints)();
  const onConfirm = (0, _react.useCallback)(() => {
    if (selectedMapPickupPoint != null && selectedPickupPoint != null) {
      onPickupPointItemConfirmation({
        deliveryChannelId: selectedMapPickupPoint.deliveryChannelId,
        deliveryFee: selectedPickupPoint.shippingFee,
        city: selectedPickupPoint.city,
        deliveryMethod: selectedPickupPoint.deliveryMethod,
        estimatedDelivery: selectedPickupPoint.estimatedDeliveryDate?.toString() ?? '',
        hintMessages: [],
        isAllowed: selectedMapPickupPoint.isAllowed,
        isDefault: false,
        isLastUsed: false,
        isPrimaryAddress: false,
        isShippingJoker: selectedPickupPoint.isShippingJoker,
        name: selectedPickupPoint.description,
        streetAddress: selectedPickupPoint.streetAddress,
        telephoneNumber: selectedPickupPoint.telephoneNumber ?? '',
        zipCode: selectedPickupPoint.zipcode,
        addressId: selectedPickupPoint.addressId,
        outOfStockQuantity: selectedPickupPoint.outOfStockQuantity,
        workingHours: selectedPickupPoint.workingHours
      });
    }
  }, [onPickupPointItemConfirmation, selectedMapPickupPoint, selectedPickupPoint]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.LeftPanelRoot, {
    "data-testid": getTestId(_models.TestId.SelectPickupPointDialogLeftMenu),
    onClick: onPickupPointsListClick,
    onTouchStart: onPickupPointsListClick,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Search.Search, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PickupPointCards.PickupPointCards, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ConfirmButtonWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
        fullWidth: true,
        maxWidth: "500px",
        "data-testid": getTestId(_models.TestId.SelectPickupPointDialoConfirmButton),
        variant: "contained",
        color: "primary",
        disabled: selectedPickupPoint == null,
        loading: loading,
        onClick: onConfirm,
        children: translations.confirm
      })
    })]
  });
};
exports.LeftPanel = LeftPanel;